import { useState } from 'react';
import './bill.component.css';

export const BillSlide = ({
    consumption,
    onFileChange,
    onConsumptionChange,
    onContinue
}: {
    consumption: number;
    onFileChange: (file: File) => void;
    onConsumptionChange: (consumption: number) => void;
    onContinue: () => void;
}) => {
    // State
    const [billFile, setBillFile] = useState<File | null>(null);

    // Constants
    const fileLimit = 10 * 1024 * 1024;

    // Handlers
    const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        const file = event.target.files?.item(0);

        // No file found
        if (!file) {
            return;
        }

        // Exceeds size limit
        if (file && file.size > fileLimit) {
            return alert('El tamaño del archivo de la factura no puede exceder los 10 MB');
        }

        setBillFile(file);
        onFileChange(file);
    }

    return (<div className="row bill">
        <div className="col-6">
            <h2>
                ¿Cuál es tu <span className="inverted">consumo energético</span> mensual?
            </h2>
            <hr className="separator green-gradient"></hr>
            <p className="p-large">
                Si es posible, <strong>adjunta tu última factura</strong> de la luz.
            </p>
            <div className="fake-input">
                <label htmlFor="bill-file" className="fake-label">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="#A4A4A4" height="32px" width="32px" viewBox="0 0 29.978 29.978">
                        <g>
                            <path d="M25.462,19.105v6.848H4.515v-6.848H0.489v8.861c0,1.111,0.9,2.012,2.016,2.012h24.967c1.115,0,2.016-0.9,2.016-2.012   v-8.861H25.462z"/>
                            <path d="M14.62,18.426l-5.764-6.965c0,0-0.877-0.828,0.074-0.828s3.248,0,3.248,0s0-0.557,0-1.416c0-2.449,0-6.906,0-8.723   c0,0-0.129-0.494,0.615-0.494c0.75,0,4.035,0,4.572,0c0.536,0,0.524,0.416,0.524,0.416c0,1.762,0,6.373,0,8.742   c0,0.768,0,1.266,0,1.266s1.842,0,2.998,0c1.154,0,0.285,0.867,0.285,0.867s-4.904,6.51-5.588,7.193   C15.092,18.979,14.62,18.426,14.62,18.426z"/>
                        </g>
                    </svg> Adjuntar factura
                </label>
                <input id="bill-file" name="billFile" type="file" onChange={handleFileChange} style={{ display: "none" }} accept="application/*,image/*" />
            </div>
            <p>{billFile?.name}</p>
            <button disabled={!consumption} onClick={onContinue} className="button">
                Continuar
            </button>
        </div>
        <div className="col-6">
            <div className="bill-preview">
                <img src={require('../../assets/bill.png')} alt="Factura" />
            </div>
            <div className="fake-input consuption-input">
                <img src={require('../../assets/euro-colored.png')} alt="Euro" />
                <input name="billConsumption" onChange={(e) => {
                    const parsedValue = parseFloat(e.target.value.replace(',', '.'));
                    onConsumptionChange(isNaN(parsedValue) ? 0 : parsedValue);
                }} type="number" min={0} step={0.01} placeholder='Importe consumo' />
            </div>
        </div>
    </div>)
}